export default __webpack_public_path__ + "static/media/stadium-bg-lg-ar.24504358.svg";